import settings from '../../modules/module--settings';

export default function() {
    const elMoveTop = $('.sidebar__move-top').addClass('--active');
    const elMoveLeft = $('.sidebar__move-left');
    $('#sidebar').addClass('sidebar--horizontal');

    const resizeSparklines = function() {
        kendo.resize($('.sparkline__wrap'));
    };

    const sidebarToTop = function() {
        settings.add({ block: 'body' }).toggle('layout-sidebar-top: true, sticky-sidebar: false');
        elMoveTop.removeClass('--active');
        elMoveLeft.addClass('--active');
        resizeSparklines();
    };
    const sidebarToLeft = function() {
        settings.add({ block: 'body' }).toggle('layout-sidebar-top: false, sticky-sidebar: true');
        elMoveTop.addClass('--active');
        elMoveLeft.removeClass('--active');
        resizeSparklines();
    };

    elMoveTop.on('click', sidebarToTop);
    elMoveLeft.on('click', sidebarToLeft);
}
